import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Col, Row, FormGroup, Card, InputGroup } from 'react-bootstrap';
import { FaCreditCard, FaUniversity, FaUser, FaCalendarAlt, FaLock } from 'react-icons/fa';
import FormContainer from '../components/FormContainer';
import CheckoutStatusBar from '../components/CheckoutStatusBar.jsx';
import CheckoutStatusBar1 from '../components/CheckoutStatusBar1.jsx';
import { savePaymentMethod, saveCreditCard } from '../slices/cartSlice';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';

const PaymentScreen = () => {
  const cart = useSelector((state) => state.cart);
  const { shippingAddress, creditCard } = cart; 
  const { userInfo } = useSelector((state) => state.auth);
  
  const [paymentMethod, setPaymentMethod] = useState(cart?.paymentMethod || 'Banka Transferi');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const [name, setName] = useState(creditCard?.name || '');
  const [cvv, setCvv] = useState(creditCard?.cvv || '');
  const [expiry, setExpiry] = useState(creditCard?.expiry || '');
  const [number, setNumber] = useState(creditCard?.number || '');
  const [ip, setIp] = useState(creditCard?.ip || '');
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  
  const offer = cart.cartItems.find(({ priceShow, advertisementShow }) => priceShow === false && advertisementShow === false);

  useEffect(() => {
    if (paymentMethod === "Kredi Kartı") {
      fetch('https://ipify.org')
        .then((res) => res.text())
        .then((fetchedIp) => setIp(fetchedIp))
        .catch(err => console.error(err));
    }
  }, [paymentMethod]);

  useEffect(() => {
    if (!shippingAddress) {
      navigate('/shipping');
    }
  }, [shippingAddress, navigate]);

  const submitHandler1 = useCallback(() => {
    navigate('/placeorder');
  }, [navigate]);

  useEffect(() => { 
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      submitHandler1();
    }
  }, [formErrors, isSubmit, submitHandler1]);

  const validate = () => {
    const errors = {};
    if (!name) errors.name = "Kart üzerindeki adı soyadı giriniz";
    if (!number) {
      errors.number = "Kart Numarasını giriniz";
    } else if (number.length < 16) {
      errors.number = "Kart Numarası eksik";
    }
    if (!expiry) {
      errors.expiry = "Ay/Yıl giriniz";
    } else if (expiry.length < 4) {
      errors.expiry = "Ay/Yıl eksik";
    }
    if (!cvv) {
      errors.cvv = "Cvv numarasını giriniz";
    } else if (cvv.length < 3) {
      errors.cvv = "Cvv Numarası eksik";
    }  
    return errors;
  };
  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(savePaymentMethod(paymentMethod));
    if (paymentMethod === 'Kredi Kartı' && !offer) {
      setFormErrors(validate());
      setIsSubmit(true);
      dispatch(saveCreditCard({ number, name, expiry, cvv, ip }));
    } else {
      navigate('/placeorder');
    }   
  };

  return (
    <div style={{ paddingTop: '10px', paddingBottom: '10px', backgroundColor: '#f8f9fa' }}>
      <FormContainer>
        {userInfo ? <CheckoutStatusBar1 step3 /> : <CheckoutStatusBar userfill step3 />}
        
         <Card  className="border-0 shadow-sm rounded-4 overflow-hidden mb-4" 
  style={{ 
    borderTop: '4px solid #004488',
    marginTop: '40px',    // Negatif margin ile aradaki dikey beyaz boşluk tamamen kapatıldı
    position: 'relative',
    zIndex: 0
  }}>
           <Card.Header className="text-white p-3 border-0" style={{ backgroundColor: '#66CCFF' }}>
             <h4 className="m-0 fw-bold fs-5 d-flex align-items-center gap-2">
              <FaCreditCard /> Ödeme Şekli ve Tercihi
            </h4>
          </Card.Header>
          <Card.Body className="p-4 bg-white">
            <Form onSubmit={submitHandler}>
              
              <div className="mb-4" style={{ display: 'flex', flexDirection: 'column', gap: '0px', width: '100%' }}>
                
                {/* 1. METOT: BANKA TRANSFERİ */}
                <div 
                  onClick={() => setPaymentMethod('Banka Transferi')}
                  style={{ 
                    cursor: 'pointer', transition: 'all 0.2s', backgroundColor: '#ffffff', padding: '15px',
                    border: '1px solid #dee2e6', borderBottom: 'none',
                    borderTopLeftRadius: '6px', borderTopRightRadius: '6px', margin: '0px',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    boxShadow: '0 .125rem .25rem rgba(0,0,0,.03)'
                  }}
                >
                  <div className="d-flex align-items-center gap-3">
                    <Form.Check
                      type='radio'
                      id='Banka Transferi'
                      name='paymentMethod'
                      value='Banka Transferi'
                      checked={paymentMethod === 'Banka Transferi'}
                      onChange={(e) => setPaymentMethod(e.target.value)}
                      style={{ cursor: 'pointer', margin: 0 }}
                    />
                    <span className="fw-bold text-dark d-flex align-items-center gap-2" style={{ fontSize: '0.85rem' }}>
                      <FaUniversity className="text-muted" /> Banka Transferi / EFT (Havale)
                    </span>
                  </div>
                </div>
                
                {/* 2. METOT: KREDİ KARTI */}
                <div 
                  onClick={() => { if (!offer) setPaymentMethod('Kredi Kartı'); }}
                  style={{ 
                    cursor: offer ? 'not-allowed' : 'pointer', transition: 'all 0.2s', backgroundColor: offer ? '#f8f9fa' : '#ffffff', padding: '15px',
                    border: '1px solid #dee2e6', borderBottomLeftRadius: '6px', borderBottomRightRadius: '6px', margin: '0px',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', opacity: offer ? 0.6 : 1,
                    boxShadow: '0 .125rem .25rem rgba(0,0,0,.03)'
                  }}
                >
                  <div className="d-flex align-items-center gap-3">
                    <Form.Check
                      type='radio'
                      id='Kredi Kartı'
                      name='paymentMethod'
                      value='Kredi Kartı'
                      checked={paymentMethod === 'Kredi Kartı'}
                      disabled={!!offer}
                      onChange={(e) => setPaymentMethod(e.target.value)}
                      style={{ cursor: offer ? 'not-allowed' : 'pointer', margin: 0 }}
                    />
                    <span className="fw-bold text-dark d-flex align-items-center gap-2" style={{ fontSize: '0.85rem' }}>
                      <FaCreditCard className="text-muted" /> Kredi Kartı ile Online Ödeme
                    </span>
                  </div>
                  {offer && <small className="text-danger fw-bold font-monospace small" style={{ fontSize: '0.75rem' }}>Teklif içeren siparişlerde kullanılamaz</small>}
                </div>
              </div>
              {/* BANKA DETAY PANELİ */}
              {paymentMethod === "Banka Transferi" && (
                <Card className="bg-light border-secondary-subtle rounded-3 p-3 mb-4 shadow-sm">
                  <div style={{ fontSize: '0.85rem', color: '#444', lineHeight: '1.6' }}>
                    <strong className="d-block mb-2 text-primary" style={{ fontSize: '0.9rem', color: '#004488' }}>
                      ADP ENDÜSTRİYEL OTOMASYON SİSTEMLERİ SAN. VE TİC. LTD. ŞTİ.
                    </strong>
                    <div className="mb-1"><strong>Banka:</strong> Kuveyt Türk Katılım Bankası - Fikirtepe Şubesi</div>
                    <div className="p-2 bg-white rounded border font-monospace fw-bold text-dark mt-2" style={{ fontSize: '0.9rem', letterSpacing: '0.5px' }}>
                      TRY IBAN: TR82 0020 5000 0977 1989 0000 02
                    </div>
                    <small className="text-muted d-block mt-2">ℹ️ Lütfen transfer açıklama kısmına sevk ismini veya sipariş kodunu yazmayı unutmayınız.</small>
                  </div>
                </Card>
              )}

              {/* KREDİ KARTI FORMU */}
              {paymentMethod === "Kredi Kartı" && !offer && (
                <div className="py-2 border-top mt-3">
                  <div className="mb-4 d-flex justify-content-center">
                    <Cards cvc={cvv} expiry={expiry} name={name} number={number} />
                  </div>
                  
                  {/* KART NUMARASI ALANI */}
                  <Form.Group className="mb-3" controlId="cardNumber">
                    <Form.Label className="fw-bold text-muted small">Kart Numarası</Form.Label>
                    <InputGroup>
                      <InputGroup.Text className="bg-light border-secondary-subtle"><FaCreditCard className="text-muted" /></InputGroup.Text>
                      <Form.Control
                        type="text"
                        placeholder="XXXX XXXX XXXX XXXX"
                        value={number}
                        maxLength={16}
                        onChange={(e) => setNumber(e.target.value.replace(/\D/g, ''))}
                        className="py-2 rounded-end-3 border-secondary-subtle font-monospace fw-semibold"
                        autoComplete="off" // Tarayıcının otomatik doldurma uyarısını engeller
                        data-lpignore="true" // LastPass vb. şifre yöneticilerini engeller
                      />
                    </InputGroup>
                    {formErrors.number && <small className="text-danger d-block mt-1 font-monospace">{formErrors.number}</small>}
                  </Form.Group>

                  {/* KART ADI ALANI */}
                  <Form.Group className="mb-3" controlId="cardName">
                    <Form.Label className="fw-bold text-muted small">Kart Üzerindeki İsim</Form.Label>
                    <InputGroup>
                      <InputGroup.Text className="bg-light border-secondary-subtle"><FaUser className="text-muted" /></InputGroup.Text>
                      <Form.Control
                        type="text"
                        placeholder="ADI SOYADI"
                        value={name}
                        onChange={(e) => setName(e.target.value.toUpperCase())}
                        className="py-2 rounded-end-3 border-secondary-subtle fw-semibold"
                        autoComplete="off" // Tarayıcının otomatik doldurma uyarısını engeller
                        data-lpignore="true" // LastPass vb. şifre yöneticilerini engeller
                      />
                    </InputGroup>
                    {formErrors.name && <small className="text-danger d-block mt-1 font-monospace">{formErrors.name}</small>}
                  </Form.Group>

                  {/* SÜRE VE CVV ALANI */}
                  <Row>
                    <Col xs={6} md={6}>
                      <Form.Group className="mb-3" controlId="cardExpiry">
                        <Form.Label className="fw-bold text-muted small">Son Kullanma Tarihi</Form.Label>
                        <InputGroup>
                          <InputGroup.Text className="bg-light border-secondary-subtle"><FaCalendarAlt className="text-muted" /></InputGroup.Text>
                          <Form.Control
                            type="text"
                            placeholder="AAYY (Örn: 1228)"
                            value={expiry}
                            maxLength={4}
                            onChange={(e) => setExpiry(e.target.value.replace(/\D/g, ''))}
                            className="py-2 rounded-end-3 border-secondary-subtle font-monospace fw-semibold"
                            autoComplete="off" // Tarayıcının otomatik doldurma uyarısını engeller
                            data-lpignore="true" // LastPass vb. şifre yöneticilerini engeller
                          />
                        </InputGroup>
                        {formErrors.expiry && <small className="text-danger d-block mt-1 font-monospace">{formErrors.expiry}</small>}
                      </Form.Group>
                    </Col>
                    
                    <Col xs={6} md={6}>
                      <Form.Group className="mb-3" controlId="cardCvv">
                        <Form.Label className="fw-bold text-muted small">Güvenlik Kodu (CVV)</Form.Label>
                        <InputGroup>
                          <InputGroup.Text className="bg-light border-secondary-subtle"><FaLock className="text-muted" /></InputGroup.Text>
                          <Form.Control
                            type="password"
                            placeholder="XXX"
                            value={cvv}
                            maxLength={3}
                            onChange={(e) => setCvv(e.target.value.replace(/\D/g, ''))}
                            className="py-2 rounded-end-3 border-secondary-subtle font-monospace fw-semibold"
                            autoComplete="off" // Tarayıcının otomatik doldurma uyarısını engeller
                            data-lpignore="true" // LastPass vb. şifre yöneticilerini engeller
                          />
                        </InputGroup>
                        {formErrors.cvv && <small className="text-danger d-block mt-1 font-monospace">{formErrors.cvv}</small>}
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              )}

              {/* SUBMIT BUTTON */}
              <Button 
                type='submit' 
                className='w-100 border-0 fw-bold transition-all shadow-sm mt-3' 
                style={{ 
                  backgroundColor: '#2b2b2b',
                  color: '#ffffff',
                  height: '46px',
                  borderRadius: '4px',
                  fontSize: '0.85rem',
                  letterSpacing: '0.5px',
                  transition: 'all 0.2s ease-in-out'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#66CCFF'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#2b2b2b'}
              >
                Bilgileri Kaydet ve Devam Et
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </FormContainer>
    </div>
  );
};

export default PaymentScreen;
